import { Component, ElementRef, Renderer2, ViewChild, Input, OnChanges, SimpleChanges } from '@angular/core';
import { getSuperType, NODE_TYPE } from '../../common/linqset-model';
import { createNodeSvg, NodeStyleSettings } from './node-svgs';

// the icon for a node type, drawn the same way as on the canvas. Give either the type or full settings
@Component({
  selector: 'app-node-svg',
  template: '<div #svgContainer class="node-svg"></div>',
  styles: ['.node-svg { display: inline-flex; line-height: 0; }'],
  standalone: false
})
export class NodeImageComponent implements OnChanges {
    @Input() caller:string          // who is showing the icon, for debugging
    @Input() settings:NodeStyleSettings
    @Input() type:NODE_TYPE
    @Input() height:number
    @Input() noText:boolean = false
    @Input() error:boolean = false

    svgElement:SVGSVGElement
    localSettings:NodeStyleSettings

    @ViewChild('svgContainer', { static: true }) svgContainer!: ElementRef<HTMLElement>;

    constructor(private renderer: Renderer2) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['type'] || changes['settings'] || changes['height'] || changes['noText'] || changes['error']) {
            this.generateImage()
        }
    }

    generateImage() {
        if (this.svgElement) {
            this.svgElement.remove()
            this.svgElement = undefined
        }

        if (!this.settings) {
            this.localSettings = new NodeStyleSettings()
            this.localSettings.type = this.type
            this.localSettings.error = this.error
            this.localSettings.noText = this.noText
            this.localSettings.superType = getSuperType(this.type)
        }else this.localSettings = this.settings

        const size = this.height || 35
        this.svgElement = createNodeSvg(this.localSettings, 0, 0, size, size)
        this.renderer.appendChild(this.svgContainer.nativeElement, this.svgElement)

    }
}